import { ToggleButtonGroup, ToggleButton } from "@mui/material";
import { useContext, useState } from "react";
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import { IOperationFilter, Modality, OperationsFieldOrderBy } from "../../../Store/Operations/types";
import StyledTooltip from "../../Misc/StyledTooltip";
import { NavigationContext } from "../../../Store/Navigation/context";

interface IFilterOperationToggleButton {
    filter: IOperationFilter,
    setFilter: (filter: IOperationFilter) => void
}

const FilterOperationToggleButton: React.FC<IFilterOperationToggleButton> = (props) => {
    const [alignment, setAlignment] = useState<string | null>("FACE_MODALITY");
    const navigationState = useContext(NavigationContext).state

    const handleAlignment = (event: React.MouseEvent<HTMLElement>, newModality: Modality) => {
        if (newModality !== null) {
            setAlignment(newModality);
            props.setFilter({...props.filter, operationsFieldToOrderBy: OperationsFieldOrderBy.OPERATION_DATE, modalities: [newModality]})
        }
    };

    return (
        <ToggleButtonGroup
            style={{height: "36.5px", minHeight: "36.5px"}}
            value={alignment}
            exclusive
            onChange={handleAlignment}
            aria-label="text alignment"
            disabled={navigationState.isLoading}
        >
            <StyledTooltip title={"Face modality"}>
                <span>
                    <ToggleButton size="small" value="FACE_MODALITY" aria-label="left aligned">
                        <PermIdentityIcon/>
                    </ToggleButton>
                </span>
            </StyledTooltip>
            <StyledTooltip title={"Voice modality"}>
                <span>
                    <ToggleButton size="small" value="VOICE_MODALITY" aria-label="centered">
                        <GraphicEqIcon/>
                    </ToggleButton>
                </span>
            </StyledTooltip>
            <StyledTooltip title={"Fingers modality"}>
                <span>
                    <ToggleButton size="small" value="FINGERS_MODALITY" aria-label="right aligned">
                        <FingerprintIcon/>
                    </ToggleButton>
                </span>
            </StyledTooltip>
        </ToggleButtonGroup>
    );
}

export default FilterOperationToggleButton